// extracted by mini-css-extract-plugin
export var actions = "_kh-g";
export var benefitCard = "_kh-b";
export var benefitIcon = "_kh-d";
export var benefitLabel = "_kh-f";
export var benefits = "_kh-a";
export var benefitsSection = "_kh-8";
export var bodyText = "_kh-7";
export var closeButton = "_kh-2";
export var content = "_kh-3";
export var eyebrow = "_kh-4";
export var heading = "_kh-5";
export var image = "_kh-i";
export var imagePanel = "_kh-h";
export var modal = "_kh-0";
export var offerCard = "_kh-c";
export var offerIcon = "_kh-e";
export var sectionLabel = "_kh-9";
export var shell = "_kh-1";
export var title = "_kh-6";